import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import {Row} from "react-bootstrap"

import {injectIntl, FormattedMessage} from "@irati/utils/lang"
import ToggleTagOnCommentMutation from "@irati/insights/apollo/mutation/comment/toggleTag"
import {Checkbox} from "@irati/ui/src/FormItem"
import {LatoLight} from "@irati/ui/src/global/fonts"
import cookieHelper from "@irati/utils/cookies"

import Modal from "../../ui/Modal"
import {Para} from "../../ui/Labels"
import {BOOKMARK_COOKIE_REMOVE} from "../../utils/constants/comment"

const StyledLabel = styled.span`
  ${LatoLight};
  vertical-align: sub;
`

class RemoveBookmarkModal extends Component {
  static propTypes = {
    formatMessage: PropTypes.func.isRequired,
    comment: PropTypes.object.isRequired
  }

  state = {
    isOpen: false,
    isChecked: false
  }

  toggleModal = () => {
    this.setState({isOpen: !this.state.isOpen})
  }

  handleBookmarkRemove = (toggleTag) => {
    const {isChecked} = this.state
    toggleTag()
    this.toggleModal()
    if (isChecked) {
      cookieHelper.setItem(BOOKMARK_COOKIE_REMOVE, true, Infinity)
    }
  }

  handleInputChange = () => {
    this.setState({isChecked: !this.state.isChecked})
  }

  render() {
    const {formatMessage, comment} = this.props
    const {isChecked, isOpen} = this.state
    return (
      <ToggleTagOnCommentMutation comment={comment}>
        {(toggleTag) => {
          return (
            <Modal
              primary={{
                onClick: () => this.handleBookmarkRemove(toggleTag),
                text: formatMessage({id: "insights.comments.bookmark.modal.removeCta"})
              }}
              secondary={{onClick: this.toggleModal, text: formatMessage({id: "insights.comments.bookmark.modal.cancelCta"})}}
              show={isOpen}
              handleClose={this.toggleModal}
              title={formatMessage({id: "insights.bookmarks.removeModal.title"})}>
              <Para medium>
                <FormattedMessage id="insights.bookmarks.removeModal.text" />
              </Para>
              <Row>
                <Checkbox name="cookie_bookmark_bypass_confirmation" checked={isChecked} onChange={this.handleInputChange}>
                  <StyledLabel> Dont ask me again</StyledLabel>
                </Checkbox>
              </Row>
            </Modal>
          )
        }}
      </ToggleTagOnCommentMutation>
    )
  }
}

export default injectIntl(RemoveBookmarkModal, {withRef: true})
